// extracted by mini-css-extract-plugin
export default {"wrapper":"AppCard_wrapper__KM3Lg","desc":"AppCard_desc__ktie9","footer":"AppCard_footer__8Qhxv","stack":"AppCard_stack__NX0hV","links":"AppCard_links__IJdo2"};